<template>
  <div class="home">
    <div class="homepage">
      <!-- 矢量，构筑企业数字化新生态 -->
      <div class="swiper">
        <IndexSwiper :isIndex="true" @totalPages = 'getPages'></IndexSwiper>
        <div class="swiper_order">
          <p>0{{ pagesInfo.index }}/0{{ pagesInfo.total }}</p>
        </div>
      </div>
      <!-- 服务范围 -->
      <div class="service">
        <Title :title="context['服务范围'].title ? context['服务范围'].title : '服务范围'" 
               :content="context['服务范围'].content ? context['服务范围'].content : '利用三维数字化技术，实现从数字化映射到决策自洽自治全生命周期解决方案'"></Title>
        <div class="service_container">
          <div class="swiper_service_container">
            <SeverSwiper></SeverSwiper>
          </div>
        </div>
      </div>
      <!-- 模型案例应用 -->
      <div class="apply">
        <Title :title="context['模型案例应用'].title ? context['模型案例应用'].title : '模型案例应用'" 
               :content="context['模型案例应用'].content ? context['模型案例应用'].content : '利用三维数字化技术，实现从数字化映射到决策自洽自治全生命周期解决方案'"></Title>
        <div class="digital_home_video">
            <div class="container">
                <img style="position: absolute; width: 50rem;
                        top: 50%; 
                        left: 50%; transform: translate(-50%, -50%); border-radius: 15px;" 
                        :src="coverUrl ? coverUrl : require('../../assets/image/资源 185.png')">
                <img style="position: absolute;
                        top: 50%; cursor: pointer;
                        left: 50%; transform: translate(-50%, -50%);"
                        @click="playVideo()"
                        src="../../assets/image/37.视频播放icon_1.png">
            </div>
            <el-dialog
                :visible.sync="centerDialogVisible"
                @close="closeVideo"
                width="100%"
                height="100%"
                center>
                <div class="video_open">
                    <video id="myVideo" class="video-js">
                    <source
                        :src="videoUrl"
                        type="video/mp4"
                    >
                    </video>
                </div>
            </el-dialog>
        </div>
      </div>
      <!-- 海量免费模型任你选 -->
      <div class="free">
        <Title :title="context['免费模型'].title ? context['免费模型'].title : '免费模型'"
               :content="context['免费模型'].content ? context['免费模型'].content : '利用三维数字化技术，实现从数字化映射到决策自洽自治全生命周期解决方案'"></Title>
        <div class="free_container">
          <div class="model_container">
            <div v-for="(item, index) in industrialModel" :key="index" class="item">
              <ModelShowFrame :name="item.name" :model="item.thumbnail"
                              :user="item.nickname" :userIcon="item.avatar"
                              :id="item.id" :type="1" :isModelCollection="false"></ModelShowFrame>
            </div>
          </div>
        </div>
      </div>
      <!-- 核心优势 -->
      <div class="advantage">
        <div class="left"></div>
        <div class="middle">
          <div class="title">
            <Title :title="context['核心优势'].title ? context['核心优势'].title : '核心优势'" 
                   :content="context['核心优势'].content ? context['核心优势'].content : '利用三维数字化技术，实现从数字化映射到决策自洽自治全生命周期解决方案'"></Title>
          </div>
          <div class="inner">
            <p style="margin-bottom: 1rem;">{{ context['核心优势'] ? context['核心优势'].digital_content1 : digitalSolutions[2].content }}</p>
            <p>{{ context['核心优势'] ? context['核心优势'].digital_content2 : digitalSolutions[3].content }}</p>
          </div>
          <div class="line">
            <img src="../../assets/image/54.线.png" width="100%">
          </div>
          <div class="content">
            <div class="core_item">
              <p style="color: #dadada; font-size: 18px; font-family: AliMedium;">{{ context['核心优势'] ? context['核心优势'].advantage1_title : coreAdvantage[0].title }}</p>
              <p style="color: #969696; font-size: 14px; font-family: AliRegular; line-height: 2;">{{ context['核心优势'] ? context['核心优势'].advantage1_content : coreAdvantage[0].content }}</p>
            </div>
            <div class="core_item core_margin">
              <p style="color: #dadada; font-size: 18px; font-family: AliMedium;">{{ context['核心优势'] ? context['核心优势'].advantage2_title : coreAdvantage[1].title }}</p>
              <p style="color: #969696; font-size: 14px; font-family: AliRegular; line-height: 2;">{{ context['核心优势'] ? context['核心优势'].advantage2_content : coreAdvantage[1].content }}</p>
            </div>
            <div class="core_item">
              <p style="color: #dadada; font-size: 18px; font-family: AliMedium;">{{ context['核心优势'] ? context['核心优势'].advantage3_title : coreAdvantage[2].title }}</p>
              <p style="color: #969696; font-size: 14px; font-family: AliRegular; line-height: 2;">{{ context['核心优势'] ? context['核心优势'].advantage3_content : coreAdvantage[2].content }}</p>
            </div>
          </div>
        </div>
        <div class="right"></div>
      </div>
      <!-- 合作伙伴 -->
      <div class="home_page_block_title">
        <Title :title="context['合作伙伴'].title ? context['合作伙伴'].title : '合作伙伴'" 
               :content="context['合作伙伴'].content ? context['合作伙伴'].content : '利用三维数字化技术，实现从数字化映射到决策自洽自治全生命周期解决方案'"></Title>
        <div class="support_container">
            <div :class="['item', i.isImage ? '' : 'item_bg']" v-for="i in support" :key="i.id" @mouseenter="showReal(i)" @mouseleave="noShowReal(i)">
              <img :src="i.isImage ? i.image : i.imageColor">
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThreeSwiper from '../../components/swiperComponent/ThreeSwiper/index'
import IndexSwiper from '../../components/swiperComponent/IndexSwiper/index'
import SeverSwiper from '../../components/swiperComponent/SeverSwiper/index'
import ModelSwiper from '../../components/swiperComponent/modelSwiper/index'
import ModelShowFrame from '../../components/modelShowFrame/index'
import Title from '../../components/title'
import { digitalSolutions, titleIndex, successfulProjects, support } from '../../util/constant'
import { getText, getVideos, getAllModelByPage } from '../../util/index'
export default {
  data() {
    return {
      centerDialogVisible:false,
      successfulProjects,
      digitalSolutions,
      titleIndex,
      support,
      modelType: "1",
      modelImage:'../../assets/model.jpg',
      userImage:"../../assets/h1.jpg",
      coverUrl: '',
      videoUrl: '',
      industrialModel:[],
      industrialModels:[],
      coreAdvantage: digitalSolutions.slice(0,3),
      pagesInfo: {
        index: 1,
        total: 5
      },
      context: {
        '首页': {},
        '模型案例应用': {},
        '服务范围': {},
        '免费模型': {},
        '解决方案': {},
        '核心优势': {},
        '合作伙伴': {}
      }
    };
  },
  mounted() {
    // this.initVideo()
    this.searchHandle()
    this.getHomeTexts()
  },
  components: {
    ThreeSwiper,
    IndexSwiper,
    SeverSwiper,
    ModelSwiper,
    Title,
    ModelShowFrame
  },
  methods: {
    getHomeTexts() {
      let page = '首页'
      getText(page).then(res=>{
        if(res.code === 200){
          let length = res.data.length
          this.context['服务范围'] = res.data[1]
          this.context['模型案例应用'] = res.data[2]
          this.context['免费模型'] = res.data[6]
          this.context['核心优势'] = res.data[3]
          this.context['合作伙伴'] = res.data[4]
          // console.log(this.context);
        }
      })
      getVideos(page).then(res=>{
        if(res.code === 200){
          this.coverUrl = res.data['index'].thumbnail
          this.videoUrl = res.data['index'].url
        }
      }).catch(err=>{
        this.$message.error(err.message) 
      })
    },
    initVideo() {
        let myPlayer = this.$video(document.getElementById('myVideo'), {
            //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
            controls: true,
            //自动播放属性,muted:静音播放
            autoplay: "muted",
            //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
            preload: "auto",
            width: 1350,
            height: 680
        });
    },
    playVideo() {
        this.centerDialogVisible = true
        setTimeout(()=>{
            this.initVideo()
        },0)
    },
    closeVideo() {
      let myPlayer = this.$video(document.getElementById('myVideo'))
      if(myPlayer){
          // 暂停视频
          myPlayer.pause();
          // 重置播放进度
          // myPlayer.currentTime = 0;
          // 清空视频源（可选，根据需求）
          // myPlayer.src = "";
      }
      this.centerDialogVisible = false

    },
    goModelDetail() {
      this.$router.push({ path: "/models_detail" });
    },
    searchHandle(){
        let modelObj = {
            isCommon: true,
            size: 10
        }
        let token  = window.localStorage.getItem('userToken')
        // 官方模型
        getAllModelByPage(modelObj, token).then(res=>{
            if(res.code === 200){
                this.industrialModel = res.data.records
                // this.industrialModels.forEach(item=>{
                //     if(item.thumbnail.slice(-3) === 'dds'){
                //         this.industrialModels.splice(this.industrialModels.indexOf(item), 1)
                //     }
                // })
                // this.industrialModel = this.industrialModels.slice(0, 10)
            } else {
                this.$message.error(res.message)
            }
        })
    },
    showReal(item){
      item.isImage = false
    },
    noShowReal(item){
      item.isImage = true
    },
    getPages(pages){
      // console.log('出发了我');
      this.pagesInfo = pages
    }
  },
};
</script>

<style scoped lang="less">
.home{
  width: 100%;
  background-color: #000;
  .homepage{
    // max-width: 1350px;
    margin: 0 auto;
  }
}
::v-deep .el-dialog{
    background-color: #000000;
    // opacity: 0.9;
    display: flex;
    justify-content: center;
    margin-top: 10vh !important;
    width: 90% !important;
}
.digital_home_video{
      max-width: var(--larger-screen-width);
      // background-color: #1e1d1d;
      // margin-top: 3rem;
      .container{
          margin: 0 auto;
          height: 500px;
          width: 70%;
          position: relative;
          background-size: cover;
          .video_dialog{
              height: 20%;
              width: 75%;
              left: 10%;
              background-color: #00000095;
              position: absolute;
              bottom: 0;
              display: flex;
              padding: 0 7rem;
              .dialog_left{
                  width: 40%;
                  margin: auto;
                  p{
                      color: rgb(255, 255, 255);
                      font-size: 1rem;
                      letter-spacing: 1px;
                      padding-bottom: 2%;
                  }
              }
              .dialog_right{
                  width: 52%;
                  display: flex;
                  align-items: center;
                  p{
                      color: rgb(255, 255, 255);
                      font-size: 0.75rem;
                      line-height: 1.7;
                      letter-spacing: 0.5px;
                      // border-left: 1px solid rgb(151 151 151);
                      padding-left: 5%;
                  }
              }
          }
      }
  }
// .title_container{
//   height: 130px;
//   // width: 500px;
//   // margin-top: 180px;
//   text-align: center;
//   p{
//     margin: 14px 0;
//   }
// }
.homepage{
  margin: 0 auto;
  width: 100%;
  min-width: 1350px;
  // background-color: #fff;
  // .swiper{
  //   height: 90vh;
  // }
  .swiper_order{
    position: absolute;
    right: 65px;
    bottom: 8px;
    padding: 3rem;
    font-family: AliBold;
    font-size: 2.5rem;
    font-weight: bolder;
    color: #fff;
    z-index: 99;
  }
  .advantage{
    width: 100%;
    background-image: url("../../assets/image/53.文字图.png");
    background-size: cover;
    display: flex;
    justify-content: center;
    max-width: 1920px;
    margin: 0 auto;
    .left{
      width: 20%;
      background-color: #020202a1;
    }
    .middle{
      // height: 60rem;
      width: 60%;
      max-width: 1600px;
      .title{
        background-color: #020202a1;
        padding: 3rem 0 1rem;
      }
      .inner{
        border-radius: 10px;
        padding: 4rem 2rem;
        // margin-bottom: 1rem;
        @media (max-width: 1600px) {
          padding: 2rem 0;
        }
        p{
          font-size: 1rem;
          color: #dadada;
          padding: 0 8rem;
          // width: 50%;
          // margin-left: 25%;
          line-height: 2;
          font-family: AliRegular;
        }
      }
      .line{
        padding-top: 2rem;
        background-color: #020202a1;
      }
      .content{
        background-color: #020202a1;
        width: 100%;
        display: flex;
        padding-bottom: 5rem;
        .core_item{
          width: 29.2%;
          padding: 2rem 0 0 0;
          margin: 0 0 0 0;
          line-height: 2;
        }
        .core_margin{
          margin: 0 68px 0 69px;
        }
      }
    }
    .right{
      width: 20%;
      background-color: #020202a1;
    }
    .mask{
      width: 80%;
      height: 100%;
      background-color: #fc2e2e83;
      .advantage_container{
        margin: 0 auto;
        width: 70%;
        height: 80rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        // background-color: #ffb8b8ac;
        .advantage_image{
          // height: 471px;
          // padding-top: 10rem;
          // margin-bottom: 2rem;
          .image_container{
            padding: 4rem 0;
            background-color: #ffffff25;
          }
          p{
            font-size: 1rem;
            color: #dadada;
            padding: 0 8rem;
            // width: 50%;
            // margin-left: 25%;
            line-height: 2;
            font-family: AliRegular;
            // margin-bottom: 1.5rem;
          }
        }
        .advantage_core{
          width: 100%;
          display: flex;
          .core_item{
            width: 29.2%;
            padding: 2rem 0 0 0;
            margin: 0 0 0 0;
            line-height: 2;
          }
          .core_margin{
            margin: 0 82px 0 85px;
          }
        }
      }
    }
  }
  .free{
    padding: 3rem 0 5rem;
    .free_container{
      // margin: 3rem 0;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: center;
    //   padding-bottom: 5%;
    //   min-width: 1350px;
    // background-color: coral;
    //   // background-image: url("../../assets/image/38.海量免费模型任你选-背景.png");
      .model_container{
          // background-color: #DDDDDD;
          max-width: 1600px;
          width: 80%;
          height: 800px;
          margin: 0 auto;
          @media screen and (max-width: 1600px) {
             height: 620px;
          }
      }
    }
  }
  .service{
    background-color: #000;
    // height: 50rem;
    padding: 3rem 0 6rem;
    .service_container{
      margin: 0 auto;
      // height: 800px;
      // background-image: url("../../assets/image/34.服务范围背景.png");
      display: flex;
      flex-direction: column;
      background-size: 120% 120%; 
      // justify-content: center;
    }
  }
  .apply{
    width: 100%;
    background-image: url("../../assets/image/资源 492-8.png");
    background-size: cover;
    // background-color: #a4fbdc;
    padding: 3rem 0 5rem;
    .apply_container{
      margin: 0 auto;
      min-width: 1380px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .video_container{
        display: flex;
        justify-content: center;
        margin-top: 3rem;
        video{
          border-radius: 15px;
        }
      }
    }
  }
  .home_page_block_title{
    padding: 3rem 0 9rem;
    // width: 1850px;
    // height: 1400px;
    // background-image: url("../../assets/image/54.合作伙伴.png");
    // margin: 0 auto;
    .support_container{
      width: 70%;
      max-width: 1350px;
      margin: 0 auto;
      // background-color: rebeccapurple;
      // height: 30rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item{
        width: 16.6%;
        // background-color: #606060;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .item_bg{
        background-color: #ffffff;
        // background-image: url('../../assets/image/logo/资源\ 386.png');
        background-size: cover;
        border-radius: 10px;
      }
    }
  }
}
::v-deep .el-dialog__headerbtn{
  z-index: 999;
  font-size: 1.5rem;
}

</style>
